// Phase 5B: route-captured args are intentionally ignored here. The
// router passes different captures depending on which path matched —
// project_slug, deal_slug, or both (compare) — so the views read all
// required state from `data-*` attributes on the rendered template
// root or from `window.location.pathname` instead of relying on
// positional args. Keeps `init` polymorphic across all 8 routes.
export function init(..._args: Array<string>): void {
	// Apply the redesign body bg (same warm gradient + #F4F2EE base
	// the project list uses). Without this, the body has no
	// background-color and any browser/preview surface that defaults
	// to dark shows through the centered, max-width Deal Calc cards.
	document.body.classList.add('lb-redesign-body');
	if (document.getElementById('id_lb-deal-compare')) {
		import('./view')
			.then(mod => (new mod.DealCalcCompareView()));
		return;
	}
	if (document.getElementById('id_lb-deal-editor')) {
		import('./view')
			.then(mod => (new mod.DealCalcEditorView()));
		return;
	}
	if (document.getElementById('id_lb-deal-list')) {
		import('./view')
			.then(mod => (new mod.DealCalcListView()));
	}
}
